<template>
  <div class="card mb-5">
    <div class="card-header" v-if="title">
      <div class="card-title">
        <fai :icon="icon"/>&nbsp; {{ title }}
      </div>
      <div class="card-btn text-right">
        <button class="m-portlet__nav-link btn  btn-outline-secondary btn-csv m-btn text-blue" @click="exportCSV">
          <fai icon="file-export"/>&nbsp; Exportar XLS
        </button>
      </div>
      <div class="card-btn text-right" v-if="create_route">
        <button class="m-portlet__nav-link btn btn-green m-btn text-white" @click="goToCreate">
          <fai icon="plus"/>&nbsp; Registrar
        </button>
      </div>
    </div>
    <div class="card-body">
      <!--begin: Search -->
      <div class="row justify-content-end">
        <div class="col col-sm-6 col-lg-4 table-search">
          <v-text-field
            v-model="tableData.search"
            append-icon="search"
            label="Búsqueda"
            @input="updateItems()"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </div>
      <!--end: Search -->

      <datatable :columns="columns" :items="items" :sortKey="sortKey" :detail_route="detail_route" :update_route="update_route" :edit_action="edit_action" :delete_action="delete_action" :sortOrders="sortOrders" @sort="sortBy">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td v-bind:class="[column.class ? column.class : 'text-left']" v-for="(column,key) in columns" :key="key">
              <a v-if="column.link == true && getPropFromItem(item, column.value, column.filter) !== null" target="_blank" v-bind:href="getPropFromItem(item, column.value, column.filter)">
                <fai icon="file-pdf"/>
              </a>
              <fai v-else-if="column.link" style="opacity: 0.5;" icon="file-pdf"/>
              <div v-if="!column.link"> {{ getPropFromItem(item, column.value, column.filter) }}</div>
            </td>
            <td class="text-center detail-icon" v-if="detail_route">
              <fai icon="eye" @click="goToDetail(item.id)"/>
            </td>
            <td class="text-center detail-icon" v-if="contract_detail_route">
              <fai icon="eye" @click="goToContract(item.contract_id)"/>
            </td>
            <td class="text-center detail-icon" v-if="edit_action">
              <fai icon="eye" @click="edit_action(item.id)"/>
            </td>
            <td class="text-center detail-icon" v-if="update_route">
              <fai :icon="['far', 'edit']" @click="goToUpdate(item.id)"/>
            </td>
            <td class="text-center danger-icon" v-if="delete_action">
              <fai icon="trash" @click="delete_action(item.id)"/>
            </td>
            <td class="text-center" v-if="custom_action">
             <fai v-if="custom_action_condition(item)" :icon="custom_action_icon" @click="custom_action(item)"/>
            </td>
          </tr>
        </tbody>
      </datatable>

      <pagination :tableData="tableData" :perPage="perPage" :pagination="pagination"
        @prev="updateItems(pagination.currentPage - 1)"
        @next="updateItems(pagination.currentPage + 1)"
        @getItems="updateItems()">
      </pagination>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import reportService from '@/services/reports'
import Datatable from '@/components/shared/Datatable'
import Pagination from '@/components/shared/Pagination'

export default {
  name: 'SysServerTable',
  props: {
    title: { type: String, required: false },
    headers: { type: Array, required: true },
    items: { type: Array, required: true },
    error_message: { type: String, required: false },
    detail_route: { type: String, required: false },
    contract_detail_route: { type: String, required: false },
    update_route: { type: String, required: false },
    create_route: { type: String, required: false },
    delete_action: { type: Function, required: false },
    edit_action: { type: Function, required: false },
    custom_action: { type: Function, required: false },
    custom_action_condition: { type: Function, required: false },
    custom_action_icon: { type: String, required: false },
    create_route_params: { type: Object, required: false, default: () => {} },
    detail_route_params: { type: Object, required: false, default: () => {} },
    update_route_params: { type: Object, required: false, default: () => {} },
    tableData: { type: Object, required: true, default: () => {} },
    pagination: { type: Object, required: true, default: () => {} },
    title_icon: { type: String | Array, required: false },
    selectable: { type: Boolean, required: false }
  },
  components: { datatable: Datatable, pagination: Pagination },
  data () {
    let sortOrders = {}
    let columns = this.headers
    columns.forEach((column) => {
      sortOrders[column.value] = -1
    })
    return {
      default_error_message: 'Sorry, there is nothing to display',
      search: '',
      title_icon_default: 'users',
      selectAll: false,
      selected: [],
      columns: columns,
      sortKey: 'deadline',
      sortOrders: sortOrders,
      perPage: ['10', '20', '30', '40', '50']
    }
  },
  methods: {
    getPropFromItem (item, property, filter) {
      let value = property.split('.').reduce((previousValue, currentValue) => {
        return (typeof previousValue !== 'object') ? '' : previousValue[currentValue]
      }, item)

      if (filter) value = (typeof filter === 'string') ? Vue.filter(filter)(value) : filter(value)

      return value
    },
    updateItems (page = 1) {
      this.$emit('getItems', page)
    },
    sortBy (key) {
      this.sortKey = key
      this.sortOrders[key] = this.sortOrders[key] * -1
      this.tableData.column = this.getIndex(this.columns, 'value', key)
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc'
      this.$emit('getItems')
    },
    getIndex (array, key, value) {
      return array.findIndex(i => i[key] == value)
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    format (value, filter) {
      if (filter) return Vue.filter(filter)(value)
      return value
    },

    goToDetail (id) {
      this.$router.push({ name: this.detail_route, params: { id } })
    },

    goToContract (id) {
      this.$router.push({ name: this.contract_detail_route, params: { id } })
    },

    exportCSV () {
      let params = this.tableData
      let page = this.$route.path
      reportService.getFile(page, params)
        .then(response => {
          window.open(response.url, '_blank')
        })
        .catch(errors => {
          console.log(errors)
        })
    },

    goToUpdate (id) {
      this.$router.push({ name: this.update_route, params: { ...this.update_route_params, ...{id} } })
    },

    goToCreate () {
      this.$router.push({ name: this.create_route, params: this.create_route_params })
    },

    selectAllRows () {
      this.selected = []
      if (!this.selectAll) {
        for (let i in this.items) {
          this.selected.push(this.items[i].id)
        }
      }
    }
  },
  computed: {
    icon: function () {
      return (this.title_icon) ? this.title_icon : this.title_icon_default
    }
  }
}
</script>

<style lang='scss' scoped>
  thead > tr > th > .form-control {
    width: 20px;
  }
  .btn-csv {
    background-color: white !important;
    color: #3D89DB;
  }
  .btn-csv:hover {
    background-color: gray !important;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/ServerTable.vue